import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/training-management')({
  component: TrainingLayout,
});

function TrainingLayout() {
  return <Outlet />;
}
